<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div class="content">
  <mat-dialog-content>
    <form class="form" [formGroup]="loginForm" (ngSubmit)="loginUser()">
      <mat-form-field appearance="outline">
        <mat-label>Username</mat-label>
        <input
          matInput
          type="text"
          name="login-username"
          formControlName="username"
          aria-describedby="usernameHelp"
        />
        @if (loginForm.controls.username?.errors?.required) {
          <mat-error>Your username is required!</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Password</mat-label>
        <input matInput type="password" name="login-password" formControlName="password" />
        @if (loginForm.controls.password?.errors?.required) {
          <mat-error>Your password is required!</mat-error>
        } @else if (loginForm.controls.password?.errors?.minlength) {
          <mat-error>Your password must be at least 8 characters long!</mat-error>
        }
      </mat-form-field>
      <button data-cy="login-button" type="submit" mat-flat-button color="primary">Login</button>
    </form>
    <span><strong>Or</strong></span>
    <button data-cy="register-button" mat-flat-button [routerLink]="'/admin/register'" color="primary">
      Register new account
    </button>
  </mat-dialog-content>
</div>
